import { capitalize } from 'remeda';

interface ICombineOptionsProps {
  trim?: boolean;
  joinWith: string;
}

interface IHumanizeOptionsProps {
  capitalize?: boolean;
}

function compact(source: (string | undefined)[]): string[] {
  return source.filter((s) => !!s) as string[];
}

export function combine(
  opts: ICombineOptionsProps | string | undefined = '',
  ...params: (string | undefined)[]
): string {
  let options: ICombineOptionsProps = { joinWith: ' ' };

  if (opts && typeof opts === 'object') {
    options = opts;
  } else {
    params = [opts, ...params];
  }

  const { joinWith, trim } = options;
  let compactedValue = compact(params);

  if (trim) {
    compactedValue = compactedValue.map((s) => s.trim());
  }

  return compactedValue.join(joinWith);
}

export function humanize(
  source: string,
  opts: IHumanizeOptionsProps = {},
): string {
  const { capitalize: toCapitalize = false } = opts;
  const humanizedSource = (source || '')
    .replace(/_/g, ' ')
    .replace(/(?!^)[A-Z]/g, (replacement) => {
      return ` ${replacement}`;
    });

  if (toCapitalize) {
    return humanizedSource
      .toLowerCase()
      .split(' ')
      .map((e) => capitalize(e))
      .join(' ');
  }

  return humanizedSource;
}

export function camelize(str: string): string {
  return str?.replace(/^([A-Z])|[\s-_/]+(\w)/g, (_match, p1, p2) => {
    if (p2) {
      return p2.toUpperCase();
    }

    return p1.toLowerCase();
  });
}

export function snakize(str: string): string {
  return str?.replace(/[A-Z]/g, (match, p1) => {
    return (p1 ? '_' : '') + match.toLowerCase();
  });
}

export function toTitle(str: string): string {
  if (!str || !str?.length) return '';

  const withSpaces = str.replace(/([A-Z])/g, ' $1');

  return withSpaces
    .trim()
    .split(/\s+/)
    .map((word) => {
      if (!word) return '';
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
}

export function hiddenEmail(email: string) {
  return email?.replace(
    /(.{0,})(...)@/,
    (match, p1, p2) => '*'.repeat(p1.length) + p2 + '@',
  );
}

export function getInitials(name?: string) {
  const trimmedName = name?.trim();
  if (!trimmedName) {
    return '';
  }

  const parts = trimmedName.split(/\s+/);
  if (parts.length < 2) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return parts[0][0].toUpperCase() + parts[parts.length - 1][0].toUpperCase();
}
